(function($) {
  $(document).ready(function() {
    $('.btn-exam').on('click', function() {
      $('.formation-content').addClass('d-none');
      $('.formation-exam').removeClass('d-none');

      if ($('.single-formation')[0]) {
        $('.single-formation').addClass('d-none');
      }

      $(window).scrollTop(0);
    });

    if (window.location.href.indexOf('?dotest') > -1) {
      $('.formation-content').addClass('d-none');
      $('.formation-exam').removeClass('d-none');

      if ($('.single-formation')[0]) {
        $('.single-formation').addClass('d-none');
      }

      $(window).scrollTop(0);
    }

    $('#questionnaire_form').validate({
      errorElement: 'span',
    });

    $('.form-test-submit').click(function(event) {
      event.preventDefault();
      var validation = $('#questionnaire_form').valid();

      if (!validation) {
        $('.alert-message').show();
        $(window).scrollTop(0);
      } else {
        $('.alert-message').hide();
      }

      if (validation) {
        var form = $('#questionnaire_form').serialize();
        //console.log(form);

        var formationid = $('#questionnaire_form').attr('data-formation-id');
        var postid = $('#questionnaire_form').attr('data-post-id');
        var userid = $('#questionnaire_form').attr('data-user-id');
        //console.log(formationid);
        $.ajax({
          type: 'POST',
          url: ajax_object.ajaxurl,
          action: 'ajax_action_questionnaire_validation',
          data: {
            action: 'ajax_action_questionnaire_validation',
            form: form,
            formationid: formationid,
            postid: postid,
            userid: userid,
          },
          success: function(response) {
            console.log(response);
            var response = $.parseJSON(response);
            console.log(response.exam_result);

            $('.formation-exam-form').empty();
            $('.formation-exam-result').removeClass('d-none');

            $('.circle').attr(
              'stroke-dasharray',
              response.exam_result + ', 100',
            );
            $('.percentage').html(response.exam_result + '%');

            $(window).scrollTop(0);

            if (response.success) {
              $('.formation-exam-result .success').show();
            } else if (!response.success && !response.game_over) {
              $('.formation-exam-result .try-again').show();
            } else {
              $('.formation-exam-result .game-over').show();
            }
          },
          error: function(response) {
            console.log('raté');
            console.log(response);
          },
        });

        // $('#questionnaire_form').submit();
      }
    });

    // $('#questionnaire_form').submit(function(event) {
    //   event.preventDefault();
    //   var form = $(this).serialize();
    //   //console.log(form);

    //   var formationid = $(this).attr('data-formation-id');
    //   var postid = $(this).attr('data-post-id');
    //   var userid = $(this).attr('data-user-id');
    //   //console.log(formationid);
    //   $.ajax({
    //     type: 'POST',
    //     url: ajax_object.ajaxurl,
    //     action: 'ajax_action_questionnaire_validation',
    //     data: {
    //       action: 'ajax_action_questionnaire_validation',
    //       form: form,
    //       formationid: formationid,
    //       postid: postid,
    //       userid: userid,
    //     },
    //     success: function(response) {
    //       console.log(response);
    //       var response = $.parseJSON(response);
    //       console.log(response.exam_result);

    //       $('.formation-exam-form').empty();
    //       $('.formation-exam-result').removeClass('d-none');

    //       $('.circle').attr('stroke-dasharray', response.exam_result + ', 100');
    //       $('.percentage').html(response.exam_result + '%');

    //       if (response.success) {
    //         $('.formation-exam-result h1').html(
    //           'Félicitations, vous avez réussi!',
    //         );
    //       } else {
    //         $('.formation-exam-result h1').html('Vous pouvez recommencer');
    //       }
    //     },
    //     error: function(response) {
    //       console.log('raté');
    //       console.log(response);
    //     },
    //   });
    // });
  });
})(jQuery);
